import React from 'react'
import { Modal } from 'react-bootstrap'
import DetailDoctor from '../DetailDoctor/index'
import DetailDoctorService from '../Service/DetailDoctorService'
import PasienService from '../Service/pasienService'
import AppointmentService from '../Service/appointmentService'
import './detaildoctor.css'
import './appointment.css'
import { config } from '../Config/config'


export default class formInput extends React.Component {


    constructor() {
        super()
        this.state = {
            listTreatment:[],

        }
    }

    loadList = async () => {
        const { idOffice } = this.props
        console.log(idOffice)

        const responListTreat = await AppointmentService.getTreatmentByDoctorOfficeId(idOffice)
        console.log(responListTreat)
        if (responListTreat.success) {
            this.setState({
                listTreatment: responListTreat.result,
            })
        }

        //     const responBio = await DetailDoctorService.getBiodata(this.state.data)
        //     if (responBio.success) {
        //         this.setState({
        //             bioList: responBio.result,
        //         })
        //         {
        //             this.state.bioList.map(data => {
        //                 this.setState({
        //                     image: data.image
        //                 })
        //             })
        //         }
        //     }

        //     const responTreat = await DetailDoctorService.getTreatment(this.state.data)
        //     if (responTreat.success) {
        //         this.setState({
        //             treatList: responTreat.result,
        //         })
        //     }

        //     const responEdu = await DetailDoctorService.getEducation(this.state.data)
        //     if (responEdu.success) {
        //         this.setState({
        //             eduList: responEdu.result,
        //         })
        //     }

        //     const responHist = await DetailDoctorService.getHistory(this.state.data)
        //     if (responHist.success) {
        //         this.setState({
        //             histList: responHist.result,
        //         })

        //         {
        //             this.state.histList.map(data => {
        //                 this.setState({
        //                     faskesList: this.state.faskesList.concat([data.faskesList])
        //                     // locParent: this.state.locParent.concat([data.locParent])
        //                 })
        //             })
        //         }
        //     }

        //     const responLoc = await DetailDoctorService.getLokasi(this.state.data)
        //     if (responHist.success) {
        //         this.setState({
        //             locList: responLoc.result
        //         })
        //         {
        //             this.state.locList.map(data => {
        //                 this.setState({
        //                     price: data.price,
        //                     faskesList: this.state.faskesList.concat([data.namaRS])
        //                     // category: data.category
        //                 })
        //             })
        //         }
        //     }
        //     const resSchedule = await DetailDoctorService.getJadwal(this.state.data)
        //     if (resSchedule.success) {
        //         this.setState({
        //             schList: resSchedule.result
        //         })
        //     }

        //     const resJanji = await PasienService.getAll()
        //     if (resJanji.success) {
        //         this.setState({
        //             relasiList: resJanji.result
        //         })
        //     }

        //     // const responFaskes = await DetailDoctorService.getFaskes(this.state.data)
        //     // if (responFaskes.success) {
        //     //     this.setState({
        //     //         faskesList: responFaskes.result,
        //     //     })
        //     // }
    }

    componentDidMount() {
        this.loadList()
    }



    janjiHandler2 = (namaRS) => {
        if (!localStorage.getItem(config.token)) {
            this.setState({
                ShowModal: true
            })
        } else {
            this.setState({
                Mode: "Buat Janji",
                ShowModalJanji: true,
                Model: this.AppointmentModel,
                faskes: namaRS
            })
        }
    }



    render() {
        const { image, Model, ShowModalJanji, relasiList, janjiList, bioList, treatList, locList,
            faskesList, faskes, List, ListCostumer_Relation, cancelHandler, errors, disabled, Mode, idOffice, listTreatment } = this.props
        // const { listTreatment } = this.state
        return (

            <div class="mb-10">
                {/* {JSON.stringify(listTreatment)} */}
                {/* {JSON.stringify(faskesList)} */}
                {/* {JSON.stringify(localStorage.getItem(config.cariIdOfficeDoctor))} */}

                <Modal show={ShowModalJanji} onHide={cancelHandler}>
                    <Modal.Header closeButton>
                        {/* <Modal.Title>{Mode}</Modal.Title> */}
                        <Modal.Title>Buat Janji Dokter</Modal.Title>

                    </Modal.Header>

                    <Modal.Body>
                        {/* {JSON.stringify(Model)} */}
                        <div class="mb-12">

                            <div class="form-group row">
                                <div class="col-md-12" style={{ paddingTop: 30 }}>
                                    <div class="profile-info-left">
                                        <div class="col-md-3 float-left">
                                            <div class="profile-img">
                                                <a href="#"><img class="avatar" src={image} alt="" /></a>
                                            </div>
                                        </div>

                                        <div class="row padding-top : 20px" style={{ marginLeft: 30 }}>
                                            <div class="col-md-12">
                                                {bioList.map(data => {
                                                    return (
                                                        <tbody>
                                                            <h3 class="text">{data.fullname}</h3>
                                                            <small class="text">{data.sp}</small>
                                                            <div class="text">{parseInt(data.Tyear) - parseInt(data.Lyear)} tahun pengalaman</div>
                                                        </tbody>
                                                    )
                                                })}
                                            </div>

                                        </div>
                                    </div>

                                    <br></br>
                                    <label for="customer_id" class="form-label lebar formInput">Konsultasi untuk*</label>
                                    <div class="lebar">
                                        <select class="form-control" id="customer_id" value={Model.customer_id} id="customer" onChange={this.props.changeHandler("customer_id")} >
                                            <option selected hidden>--Pilih--</option>
                                            {
                                                relasiList.map(data => {
                                                    // janjiList.map(data => {
                                                    return (
                                                        <option value={data._id}>{data.nama}, {data.hubungan}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                        {/* <span className="error">* Pasien harus diisi</span> */}
                                        <span class="error1">{errors["customer"]}</span>
                                    </div>
                                    {/* <p class="error ml-3">{errors["customer_id"]}</p> */}

                                    <br></br>
                                    <label for="faskes" class="form-label lebar formInput">Faskes*</label>
                                    <div class="lebar">
                                        {/* <select class="form-control fontFormInput" value={faskes}>
                                            <option >{faskes}</option> */}
                                        <select class="form-control" id="faskes_name" value={Model.doctor_office_id} onChange={this.props.changeHandler("doctor_office_id")}>
                                            {/* <select class="form-control" id="faskes_name" value={Model.doctor_office_id}> */}
                                            {/* <option selected hidden>--Pilih--</option> */}
                                            {/* <option value={faskesList._id}>{faskesList.namaRS}</option> */}


                                            {
                                                faskesList.map(data => {
                                                    if (idOffice == data._id) {
                                                        return (
                                                            <option>{data.namaRS}</option>
                                                        )
                                                    }
                                                })
                                            }
                                        </select>
                                    </div>
                                    {/* <p class="error1">{errors["faskes"]}</p> */}

                                    <br></br>
                                    <label for="appointment_date" class="form-label lebar formInput">Waktu Kedatangan*</label>
                                    <div class="lebar">
                                        <input type="datetime-local" time-format="yyyy-mm-dd" class="form-control" id="appointment_date" disabled={disabled} onChange={this.props.changeHandler("appointment_date")} />
                                    
                                    {/* <span className="error" class="error1">{errors["tanggal_janji_expired"]}</span> */}
                                    <span className="error" class="error1">{errors["tanggal_janji_expired"]}</span>
                                    </div>

                                   
                                    <br></br>
                                    <label for="doctor_office_treatment_id" class="form-label lebar formInput">Tindakan Medis*</label>
                                    <div class="lebar">
                                        <select class="form-control fontFormInput" id="doctor_office_treatment_id" value={Model.doctor_office_treatment_id} disabled={disabled} onChange={this.props.changeHandler('doctor_office_treatment_id')} >
                                            <option selected hidden>--Pilih--</option>
                                            {
                                                listTreatment.map(data => {
                                                    return (
                                                        <option value={data._id}>{data.treatment[0]}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                        <span class="error1">{errors["tindakan"]}</span>

                                    </div>




                                    {/* <p class="error ml-3">{errors["customer_relation_id"]}</p> */}
                                </div>
                                <br></br>
                            </div>
                        </div>


                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" class="btn btn-primary" onClick={this.props.saveHandler}>Submit</button>
                        <button type="button" class="btn btn-primary" onClick={cancelHandler}>Cancel</button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}
